'use strict';
import React from 'react';
import * as T from 'prop-types';
import {getIcon} from './file-icons';
import {icons} from './icons';


export function SvgIcon(props) {
  return React.createElement(
    'svg',
    {
      className: props.className,
      style: props.style,
      viewBox: '0 0 1024 1024',
      dangerouslySetInnerHTML: {
        __html: `<title>${props.title || props.icon}</title>${getIconSvg(props)}`,
      },
    }
  );
}

function getIconSvg(props) {
  if (props.isFile) {
    return getIcon(props.filename);
  } else {
    return icons[props.icon];
  }
}

SvgIcon.propTypes = {
  className: T.string,
  title: T.string,
  isFile: T.bool,
  filename: T.string,

  icon: T.oneOf(Object.keys(icons)),
};



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/SvgIcon.js